import React, { useEffect, useState } from 'react'
import Iframe from 'react-iframe';
import { useForm, FormProvider } from "react-hook-form"
import { Box, Paper, Stack, Button, Collapse, Card, Grid, useTheme, } from "@mui/material"

import { useSelector } from 'react-redux';
import { getUser } from 'store/authSlice';

import * as api from '../../../pages/services/api'
import Loader from 'components/Loader';
import CircleIcon from '@mui/icons-material/Circle';
import _ from 'lodash'


function Index() {

    const [profile, setProfile] = useState('')
    const user = useSelector(getUser);
    const [loading, setLoading] = useState(false)

    const [consentStatus, setConsentStatus] = useState(false)

    const [inform, setInform] = useState([])
    const [menuSelected, setMenuSelected] = useState();

    useEffect(() => {
        consent(user.card_id)
    }, [])

    const methods = useForm({
        defaultValues: {

        },
    });

    const handleOpenHealthlink = () => {
        window.open(`https://portal.healthlink.go.th/auth/ddopa`, '_blank');
    }

    const consent = async (pid) => {
        setLoading(true)
        let res = await api.consent(pid)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                // console.log(res['data']['data'])
                setConsentStatus(res['data']['data']['consent_status'])
                information(pid)
            } else if (res['data']['code'] === 204) {
                setConsentStatus(res['data']['data']['consent_status'])
            } else {
                console.log(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const information = async (pid) => {
        setLoading(true)
        let res = await api.information(pid)
        // let res = await api.information(1103900042982)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                console.log(res['data']['data'])

                let raw = res['data']
                // let raw = {
                //     data: {
                //         visit_list: [
                //             {
                //                 "bmi": "-",
                //                 "bp": "-",
                //                 "bt": "-",
                //                 "bw": "-",
                //                 "cc": "-",
                //                 "hos_id": "001067600",
                //                 "hos_name": "รพ.พุทธชินราช",
                //                 "ht": "-",
                //                 "pe": "",
                //                 "pi": "-",
                //                 "pid": "5901199038191",
                //                 "pr": "-",
                //                 "rr": "-",
                //                 "sat_o2": "-",
                //                 "visit_date": "2015-02-03",
                //                 "visit_time": "08:03"
                //             },
                //             {
                //                 "bmi": "22.60",
                //                 "bp": "109/69mmHg.",
                //                 "bt": "36.5 C",
                //                 "bw": "71.6 Kg.",
                //                 "cc": "มาตรวจสุขภาพประจำปี โปรแกรม CU 761 01 ก.ค. 63 , 13.26 น.",
                //                 "hos_id": "001497200",
                //                 "hos_name": "รพ.มหาวิทยาลัยนเรศวร",
                //                 "ht": "178 Cm.",
                //                 "pe": "01 ก.ค. 63,09.29 น.",
                //                 "pi": "เคยตรวจสุขภาพประจำปี  ปี 2562\r\nPH  ไม่มีโรคประจำตัว  ไม่มีประวัติการแพ้ยา \r\nไม่มีประวัติไอเรื้อรัง/นน.ลด/contact TB\r\nHx บิดา ไม่มีโรคประจำตัว มารดา ไม่มีโรคประจำตัว \r\nดื่มแอลกอฮอล์ตามเทศกาล  /ไม่สูบบุหรี่  LMP   วัน 01 ก.ค. 63 , 13.26 น.",
                //                 "pid": "5901199038191",
                //                 "pr": "85/min.",
                //                 "rr": "20/min.",
                //                 "sat_o2": "-",
                //                 "visit_date": "2020-07-01",
                //                 "visit_time": "08:29:02"
                //             },
                //         ],
                //         lab_list: [
                //             {
                //                 "hos_id": "001497200",
                //                 "hos_name": "รพ.มหาวิทยาลัยนเรศวร",
                //                 "lab_list": [
                //                     {
                //                         "detail": [
                //                             "Alkaline Phosphatase normal[40-130 U/L] 47",
                //                             "SGPT (ALT) normal[5-41 U/L] 29",
                //                             "SGOT (AST) normal[5-40 U/L] 29",
                //                             "BUN normal[6.0-20.0 mg/dL] 14.6",
                //                             "WBC normal[4.50-11.30 x10 3cell/uL] 6.45",
                //                             "RBC normal[4.20-6.10 x10 6cell/uL] 6.19 - H",
                //                             "Hb normal[12.7-16.9 g/dL] 15.8",
                //                             "HCT normal[40.3-51.9 %] 44.7",
                //                             "MCV normal[80.6-98.8 fL] 72.2 - L",
                //                             "MCH normal[25.8-33.1 pg] 25.5 - L",
                //                             "MCHC normal[30.8-34.6 g/dL] 35.3 - H",
                //                             "RDW normal[11.9-14.5 %] 16.4 - H",
                //                             "Platelet normal[160.0-356.0 x10 3cell/uL] 260.0",
                //                             "Neutrophil normal[40.0-70.3 %] 46.0",
                //                             "Absolute Neutrophil normal[2.10-7.20 10 3/uL] 2.97",
                //                             "Lymphocyte normal[18.7-48.3 %] 36.6",
                //                             "Monocyte normal[3.9-12.3 %] 5.0",
                //                             "Eosinophil normal[0.8-9.2 %] 11.0 - H",
                //                             "BASO normal[0.1-1.4 %] 1.4",
                //                             "Diff 100% normal[- ] 100.00 - ",
                //                             "Creatinine normal[0.67-1.17 mg/dL] 1.19 - H",
                //                             "EGFR-EPI(CKD-EPI) normal[- ml/min/1.73m] 71.29 - ",
                //                             "GlucoseFBS normal[74-106 mg/dL] 91",
                //                             "Cholesterol normal[4-200 mg/dL] 140",
                //                             "Triglyceride normal[9-150 mg/dL] 89",
                //                             "HDL normal[55- mg/dL] 41 - L",
                //                             "LDL-Calculate normal[4-130 mg/dL] 81",
                //                             "Color ( UE ) normal[- ] Yellow - ",
                //                             "Transparency normal[- ] Clear - ",
                //                             "Specific Gravity normal[1.003-1.030 ] 1.026",
                //                             "pH normal[4.6-8.0 ] 6.5",
                //                             "Leukocyte normal[- ] Negative - ",
                //                             "Nitrite normal[- ] Negative - ",
                //                             "Urine Protein(strip) normal[- ] Trace - ",
                //                             "Urine Glucose(strip) normal[- ] Negative - ",
                //                             "Ketone normal[- ] Negative - ",
                //                             "Urobilinogen normal[- ] NORMAL - ",
                //                             "Bilirubin normal[- ] Negative - ",
                //                             "Erythrocyte normal[- ] Negative - ",
                //                             "Epithelium Cells normal[- ] 1-2 Cells/HPF - ",
                //                             "Urine WBC normal[- ] 2-3 Cells/HPF - ",
                //                             "Urine RBC normal[- ] 1-2 Cells/HPF - ",
                //                             "Mucous Thread normal[- ] Few - ",
                //                             "Bacteria normal[- ] Few - ",
                //                             "Uric Acid normal[3.4-7.0 mg/dL] 5.0"
                //                         ],
                //                         "ordername": "Uric acid",
                //                         "reporter_name": "นส. ตรีคูณ บำรุงพงศ์( ทน.14886 )"
                //                     }
                //                 ],
                //                 "pid": "5901199038191",
                //                 "visit_date": "2015-02-03",
                //                 "visit_time": "08:29:02"
                //             },
                //             {
                //                 "hos_id": "001497200",
                //                 "hos_name": "รพ.มหาวิทยาลัยนเรศวร",
                //                 "lab_list": [
                //                     {
                //                         "detail": [
                //                             "Alkaline Phosphatase normal[40-130 U/L] 41",
                //                             "SGPT (ALT) normal[5-41 U/L] 29",
                //                             "SGOT (AST) normal[5-40 U/L] 25",
                //                             "BUN normal[6.0-20.0 mg/dL] 11.9",
                //                             "WBC normal[3.70-9.90 x10 3cell/uL] 6.02",
                //                             "RBC normal[4.00-5.80 x10 6cell/uL] 6.44 - H",
                //                             "Hb normal[13.0-16.0 g/dL] 15.9",
                //                             "HCT normal[38.0-48.0 %] 45.5",
                //                             "MCV normal[77.0-100.0 fL] 70.7 - L",
                //                             "MCH normal[25.0-34.0 pg] 24.7 - L",
                //                             "MCHC normal[31.0-36.0 g/dL] 34.9",
                //                             "RDW normal[12.2-14.6 %] 17.2 - H",
                //                             "PDW normal[9.0-14.0 fL] 10.8",
                //                             "MPV normal[6.5-10.2 fL] 9.4",
                //                             "Platelet normal[143.0-343.0 x10 3cell/uL] 259.0",
                //                             "Neutrophil normal[35.4-67.6 %] 52.8",
                //                             "Absolute Neutrophil normal[- 10 3/uL] 3.18 - ",
                //                             "Lymphocyte normal[20.8-49.7 %] 34.7",
                //                             "Monocyte normal[2.8-8.2 %] 8.5 - H",
                //                             "Eosinophil normal[0.0-9.0 %] 2.7",
                //                             "BASO normal[0.7-1.3 %] 1.3",
                //                             "Diff 100% normal[- ] 100.00 - ",
                //                             "Creatinine normal[0.67-1.17 mg/dL] 1.22 - H",
                //                             "EGFR-EPI(CKD-EPI) normal[- ml/min/1.73m] 69.66 - ",
                //                             "GlucoseFBS normal[74-109 mg/dL] 98",
                //                             "HBc Antibody value normal[- COI] 2.270 - ",
                //                             "HBc Antibody Result normal[- ] Negative - ",
                //                             "HBs Antigen value normal[0.000-0.990 COI] 0.293",
                //                             "HBs Antigen Result normal[- ] Negative - ",
                //                             "HBs Antibody Value normal[0.00-9.99 IU/L] 2.00",
                //                             "HBs Antibody Result normal[- ] Negative - ",
                //                             "Cholesterol normal[4-200 mg/dL] 150",
                //                             "Triglyceride normal[9-150 mg/dL] 106",
                //                             "HDL normal[- mg/dL] 42 - L",
                //                             "LDL-Calculate normal[4-130 mg/dL] 87",
                //                             "Color ( UE ) normal[- ] Yellow - ",
                //                             "Transparency normal[- ] Clear - ",
                //                             "Specific Gravity normal[1.003-1.030 ] 1.021",
                //                             "pH normal[4.6-8.0 ] 6.0",
                //                             "Leukocyte normal[- ] Negative - ",
                //                             "Nitrite normal[- ] Negative - ",
                //                             "Urine Protein(strip) normal[- ] Trace - ",
                //                             "Urine Glucose(strip) normal[- ] Negative - ",
                //                             "Ketone normal[- ] Negative - ",
                //                             "Urobilinogen normal[- ] Negative - ",
                //                             "Bilirubin normal[- ] Negative - ",
                //                             "Erythrocyte normal[- ] Negative - ",
                //                             "Epithelium Cells normal[- ] 0-1 Cells/HPF - ",
                //                             "Urine WBC normal[- ] 0-1 Cells/HPF - ",
                //                             "Urine RBC normal[- ] 0-1 Cells/HPF - ",
                //                             "Uric Acid normal[3.4-7.0 mg/dL] 5.2"
                //                         ],
                //                         "ordername": "Uric acid",
                //                         "reporter_name": "นส. ศิริพร บุญชัชวาลย์วงศ์( ทน.12058 )"
                //                     }
                //                 ],
                //                 "pid": "5901199038191",
                //                 "visit_date": "2020-07-01",
                //                 "visit_time": "07:27:06"
                //             },
                //         ],
                //         diagnosis_list: [
                //             {
                //                 "hos_id": "001067600",
                //                 "hos_name": "รพ.พุทธชินราช",
                //                 "diagnosis": [
                //                     {
                //                         "diag": "Z000   GENERAL MEDICAL EXAMINATION",
                //                         "diagnosis_date": "2015-02-03"
                //                     }
                //                 ],
                //                 "pid": "5901199038191",
                //                 "visit_date": "2015-02-03",
                //                 "visit_time": "08:03"
                //             },
                //             {
                //                 "hos_id": "001497200",
                //                 "hos_name": "รพ.มหาวิทยาลัยนเรศวร",
                //                 "diagnosis": [
                //                     {
                //                         "diag": "Z000  General medical examination (Z000  General medical examination)",
                //                         "diagnosis_date": "2020-07-01"
                //                     }
                //                 ],
                //                 "pid": "5901199038191",
                //                 "visit_date": "2020-07-01",
                //                 "visit_time": "08:29:02"
                //             },
                //         ],
                //         medication_list: [
                //             {
                //                 "hos_id": "001497200",
                //                 "hos_name": "รพ.มหาวิทยาลัยนเรศวร",
                //                 "order_list": [
                //                     {
                //                         "med": "Zyrtec_CETIRIzine_TAB_10 mg_ข , 1*1",
                //                         "verify_date": "2020-03-04"
                //                     },
                //                     {
                //                         "med": "Acyclovir 800 mg tab_ก , รับประทานครั้งละ 1 เม็ด วันละ 4 ครั้ง เวลา 6.00น.,10.00น.,14.00น.,18.00น.,",
                //                         "verify_date": "2020-03-04"
                //                     }
                //                 ],
                //                 "pid": "5901199038191",
                //                 "visit_date": "2015-02-03",
                //                 "visit_time": "11:05:43"
                //             },
                //             {
                //                 "hos_id": "001497200",
                //                 "hos_name": "รพ.มหาวิทยาลัยนเรศวร",
                //                 "order_list": [
                //                     {
                //                         "med": "PARAcetamol_TAB_500 mg._ก(MASA) , 1q4-6prn",
                //                         "verify_date": "2017-07-20"
                //                     },
                //                     {
                //                         "med": "Oseltamivir 75 mg tab_จ(1) , 1*bidpc",
                //                         "verify_date": "2017-07-20"
                //                     },
                //                     {
                //                         "med": "codeine+GG (10/100) ROPECT(PML)_ค , 1*3pc",
                //                         "verify_date": "2017-07-20"
                //                     }
                //                 ],
                //                 "pid": "5901199038191",
                //                 "visit_date": "2020-07-01",
                //                 "visit_time": "12:33:06"
                //             },
                //         ],
                //         allergy_list: [
                //             {
                //                 "hos_id": "001497200",
                //                 "hos_name": "รพ.มหาวิทยาลัยนเรศวร",
                //                 "allergy_list": [
                //                     {
                //                         "med": "Zyrtec_CETIRIzine_TAB_10 mg_ข , 1*1",
                //                         "verify_date": "2020-03-04"
                //                     }
                //                 ],
                //                 "pid": "5901199038191",
                //                 "visit_date": "2015-02-03",
                //                 "visit_time": "11:05:43"
                //             },
                //             {
                //                 "hos_id": "001497200",
                //                 "hos_name": "รพ.มหาวิทยาลัยนเรศวร",
                //                 "allergy_list": [
                //                     {
                //                         "med": "PARAcetamol_TAB_500 mg._ก(MASA) , 1q4-6prn",
                //                         "verify_date": "2017-07-20"
                //                     }
                //                 ],
                //                 "pid": "5901199038191",
                //                 "visit_date": "2020-07-01",
                //                 "visit_time": "12:33:06"
                //             },
                //         ]
                //     }
                // }
                let date_list = raw.data.visit_list.map(item => ({ hos_id: item.hos_id, visit_date: item.visit_date, visit_list: [], lab_list: [], diagnosis_list: [], medication_list: [], allergy_list: [] }));
                date_list = date_list.concat(raw.data.lab_list.map(item => ({ hos_id: item.hos_id, visit_date: item.visit_date, visit_list: [], lab_list: [], diagnosis_list: [], medication_list: [], allergy_list: [] })));
                date_list = date_list.concat(raw.data.diagnosis_list.map(item => ({ hos_id: item.hos_id, visit_date: item.visit_date, visit_list: [], lab_list: [], diagnosis_list: [], medication_list: [], allergy_list: [] })));
                date_list = date_list.concat(raw.data.medication_list.map(item => ({ hos_id: item.hos_id, visit_date: item.visit_date, visit_list: [], lab_list: [], diagnosis_list: [], medication_list: [], allergy_list: [] })));
                date_list = date_list.concat(raw.data.allergy_list.map(item => ({ hos_id: item.hos_id, visit_date: item.visit_date, visit_list: [], lab_list: [], diagnosis_list: [], medication_list: [], allergy_list: [] })));
                date_list = _.orderBy(_.uniqBy(date_list, 'visit_date'), ['visit_date'], ['desc'])

                date_list.forEach((item_) => {
                    item_.visit_list = raw.data.visit_list.filter(item => item.visit_date === item_.visit_date)
                    item_.lab_list = raw.data.lab_list.filter(item => item.visit_date === item_.visit_date)
                    item_.diagnosis_list = raw.data.diagnosis_list.filter(item => item.visit_date === item_.visit_date)
                    item_.medication_list = raw.data.medication_list.filter(item => item.visit_date === item_.visit_date)
                    item_.allergy_list = raw.data.allergy_list.filter(item => item.visit_date === item_.visit_date)
                })
                setInform(date_list)
                console.log(date_list)
                setMenuSelected(Array(date_list.length).fill(0))
            } else {
                console.log(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const dataSetMenu = (index, value) => {
        let tmp = menuSelected;
        if (menuSelected.length != inform.length) {
            tmp = Array(inform.length).fill(0);
        }

        tmp[index] = value;
        setMenuSelected([...tmp]);
    }

    const convertDate = (dataDate) => {
        const date = new Date(dataDate)
        const optionDate = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            timeZone: 'UTC',
        }

        const thaiLocale = 'th-TH';
        const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

        const newDate = `${formattedDate}`
        return newDate
    }


    return (
        <Box>
            <Loader loading={loading} />

            <FormProvider {...methods}>
                <Paper
                    sx={{
                        p: "10px",
                        // display: "flex",
                        // flexDirection: "column",
                        // gap: "5px",
                        // flex: 1,
                        // overflow: "hidden",
                        // height: '70vh',
                    }}
                >
                    {/* <Button
                        sx={{ display: 'flex', gridGap: '10px' }}
                        variant='outlined'
                        onClick={handleOpenHealthlink}
                    // onClick={() => { alert('ยังไม่เปิดให้บริการ') }}
                    >
                        <img src={'/assets/icons/thaiD.svg'} style={{ width: '35px' }} />
                        <div>แอพลิเคชัน thaiD</div>
                    </Button>
                    <Iframe
                        url="https://healthlink.go.th/"
                        width="100%"
                        height="100%"
                        id="webview"
                        display="initial"
                        position="relative"
                        frameBorder="0" // This removes the border
                        style={{ border: 'none' }} // Additional CSS to remove the border
                    /> */}
                    <Box sx={{
                        border: '1px solid #478F96',
                        borderRadius: '10px',
                        padding: '10px',
                        overflow: 'auto'
                    }}>
                        {consentStatus === false ?
                            <>
                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    height: '20vh',
                                    color: '#478F96'
                                }}>
                                    <Box>ท่านยังไม่มีการ Consent จาก HealthLink</Box>
                                </Box>

                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'flex-end'
                                }}>
                                    <Button
                                        variant='contained'
                                        onClick={handleOpenHealthlink}
                                    >
                                        <div>เชื่อมโยงข้อมูล HealthLink</div>
                                    </Button>
                                </Box>
                            </>

                            :
                            <Box>
                                {inform.length > 0 ?
                                    <Box sx={{
                                        display: 'grid',
                                        gridGap: '20px',
                                        overflow: 'auto',
                                        height: '50vh'
                                    }}>
                                        {inform.map((i, idx) => (
                                            <Box sx={{
                                                display: 'grid',
                                                gridTemplateColumns: '1fr 3fr',
                                                border: 1,
                                                borderColor: '#E1E3E9',
                                                borderRadius: '10px',
                                                height: '400px',
                                                '@media (max-width: 800px)': {
                                                    gridTemplateColumns: '1fr 2fr',
                                                }
                                            }} key={idx}>
                                                <Box sx={{
                                                    backgroundColor: '#C8EBEB',
                                                    borderRadius: '10px',
                                                    padding: '20px',
                                                    display: 'grid',
                                                    gridGap: '20px'
                                                }}>
                                                    <Box sx={{
                                                        color: '#478F96',
                                                        fontWeight: 700,
                                                        fontSize: '24px',
                                                        textAlign: 'center',
                                                        '@media (max-width: 1024px)': {
                                                            fontSize: 18,
                                                        },
                                                        '@media (max-width: 800px)': {
                                                            fontSize: 14,
                                                        }
                                                    }}>{convertDate(i['visit_date'])}</Box>
                                                    <Button onClick={() => { dataSetMenu(idx, 0) }} variant={menuSelected[idx] === 0 ? 'contained' : 'outlined'}>ประวัติการแพทย์</Button>
                                                    <Button onClick={() => { dataSetMenu(idx, 1) }} variant={menuSelected[idx] === 1 ? 'contained' : 'outlined'}>ผลแลป</Button>
                                                    <Button onClick={() => { dataSetMenu(idx, 2) }} variant={menuSelected[idx] === 2 ? 'contained' : 'outlined'}>การวินิจฉัย</Button>
                                                    <Button onClick={() => { dataSetMenu(idx, 3) }} variant={menuSelected[idx] === 3 ? 'contained' : 'outlined'}>การจ่ายยา</Button>
                                                    <Button onClick={() => { dataSetMenu(idx, 4) }} variant={menuSelected[idx] === 4 ? 'contained' : 'outlined'}>การแพ้</Button>
                                                </Box>

                                                <Box>
                                                    {menuSelected[idx] === 0 ?
                                                        <Box sx={{ padding: '20px', height: '350px' }}>
                                                            <Box sx={{ color: '#478F96', fontWeight: 700, fontSize: 20 }}>ประวัติการแพทย์</Box>
                                                            {i['visit_list'].length > 0 ?
                                                                <Box sx={{ maxHeight: '310px', overflowY: "auto" }}>
                                                                    {i['visit_list'].map((item, index) => (
                                                                        <Box key={index} >
                                                                            <Box sx={{ color: '#478F96', fontWeight: 700 }}>{item['hos_name']}</Box>
                                                                            <Box sx={{
                                                                                display: 'grid',
                                                                                gridTemplateColumns: '1fr 1fr 1fr',
                                                                                margin: '20px',
                                                                                '@media (max-width: 800px)': {
                                                                                    gridTemplateColumns: '1fr'
                                                                                }
                                                                            }}>
                                                                                <Box>
                                                                                    <div style={{ fontWeight: 700, color: '#478F96' }}>CC</div>
                                                                                    <div style={{ margin: '0 10%' }}>{item['cc'] === '' ? '-' : item['cc']}</div>
                                                                                </Box>
                                                                                <Box>
                                                                                    <div style={{ fontWeight: 700, color: '#478F96' }}>Ht</div>
                                                                                    <div style={{ margin: '0 10%' }}>{item['ht'] === '' ? '-' : item['ht']}</div>
                                                                                </Box>
                                                                                <Box>
                                                                                    <div style={{ fontWeight: 700, color: '#478F96' }}>Pi</div>
                                                                                    <div style={{ margin: '0 10%' }}>{item['pi'] === '' ? '-' : item['pi']}</div>
                                                                                </Box>
                                                                                <Box>
                                                                                    <div style={{ fontWeight: 700, color: '#478F96' }}>Bt</div>
                                                                                    <div style={{ margin: '0 10%' }}>{item['bt'] === '' ? '-' : item['bt']}</div>
                                                                                </Box>
                                                                                <Box>
                                                                                    <div style={{ fontWeight: 700, color: '#478F96' }}>Pe</div>
                                                                                    <div style={{ margin: '0 10%' }}>{item['pe'] === '' ? '-' : item['pe']}</div>
                                                                                </Box>
                                                                                <Box>
                                                                                    <div style={{ fontWeight: 700, color: '#478F96' }}>Rr</div>
                                                                                    <div style={{ margin: '0 10%' }}>{item['rr'] === '' ? '-' : item['rr']}</div>
                                                                                </Box>
                                                                                <Box>
                                                                                    <div style={{ fontWeight: 700, color: '#478F96' }}>Bp</div>
                                                                                    <div style={{ margin: '0 10%' }}>{item['bp'] === '' ? '-' : item['bp']}</div>
                                                                                </Box>
                                                                                <Box>
                                                                                    <div style={{ fontWeight: 700, color: '#478F96' }}>Bmi</div>
                                                                                    <div style={{ margin: '0 10%' }}>{item['bmi'] === '' ? '-' : item['bmi']}</div>
                                                                                </Box>
                                                                                <Box>
                                                                                    <div style={{ fontWeight: 700, color: '#478F96' }}>Pr</div>
                                                                                    <div style={{ margin: '0 10%' }}>{item['pr'] === '' ? '-' : item['pr']}</div>
                                                                                </Box>
                                                                                <Box>
                                                                                    <div style={{ fontWeight: 700, color: '#478F96' }}>sat O2</div>
                                                                                    <div style={{ margin: '0 10%' }}>{item['sat_o2'] === '' ? '-' : item['sat_o2']}</div>
                                                                                </Box>
                                                                                <Box>
                                                                                    <div style={{ fontWeight: 700, color: '#478F96' }}>Bw</div>
                                                                                    <div style={{ margin: '0 10%' }}>{item['bw'] === '' ? '-' : item['bw']}</div>
                                                                                </Box>
                                                                            </Box>
                                                                        </Box>
                                                                    ))}
                                                                </Box>
                                                                :
                                                                <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>ไม่พบข้อมูล</Box>
                                                            }
                                                        </Box>
                                                        : null
                                                    }

                                                    {menuSelected[idx] === 1 ?
                                                        <Box sx={{ padding: '20px', height: '350px' }}>
                                                            <Box sx={{ color: '#478F96', fontWeight: 700, fontSize: 20 }}>ผลแลป</Box>
                                                            {i['lab_list'].length > 0 ?
                                                                <Box sx={{ maxHeight: '310px', overflowY: "auto" }}>
                                                                    {i['lab_list'].map((item, index) => (
                                                                        <Box key={index}>
                                                                            <Box sx={{ color: '#478F96', fontWeight: 700 }}>{item['hos_name']}</Box>
                                                                            {item['lab_list'].map((i, idx) => (
                                                                                <Box key={idx}>
                                                                                    <Box sx={{ fontWeight: 700, color: '#478F96', fontSize: 16 }}>{i['ordername']}</Box>
                                                                                    {i['detail'].map((item, index) => (
                                                                                        <Box key={index} sx={{ display: 'flex', gridGap: 5, margin: '0 10px' }}>
                                                                                            <CircleIcon style={{ width: '5px' }} /> {item}
                                                                                        </Box>
                                                                                    ))}
                                                                                </Box>
                                                                            ))}
                                                                        </Box>
                                                                    ))}
                                                                </Box>
                                                                :
                                                                <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>ไม่พบข้อมูล</Box>
                                                            }
                                                        </Box>
                                                        : null
                                                    }

                                                    {menuSelected[idx] === 2 ?
                                                        <Box sx={{ padding: '20px', height: '350px' }}>
                                                            <Box sx={{ color: '#478F96', fontWeight: 700, fontSize: 20 }}>การวินิจฉัย</Box>
                                                            {i['diagnosis_list'].length > 0 ?
                                                                <Box sx={{ height: '310px', overflowY: "auto" }}>
                                                                    {i['diagnosis_list'].map((item, index) => (
                                                                        <Box key={index} >
                                                                            <Box sx={{ color: '#478F96', fontWeight: 700, marginBottom: '20px' }}>{item['hos_name']}</Box>
                                                                            {item['diagnosis'].map((i, idx) => (
                                                                                <Box key={idx} sx={{ display: 'flex', gridGap: 5, margin: '0 20px' }}>
                                                                                    <CircleIcon style={{ width: '5px' }} /> {i['diag']}
                                                                                </Box>
                                                                            ))}
                                                                        </Box>
                                                                    ))}
                                                                </Box>
                                                                :
                                                                <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>ไม่พบข้อมูล</Box>
                                                            }
                                                        </Box>
                                                        : null
                                                    }

                                                    {menuSelected[idx] === 3 ?
                                                        <Box sx={{ padding: '20px', height: '350px' }}>
                                                            <Box sx={{ color: '#478F96', fontWeight: 700, fontSize: 20 }}>การจ่ายยา</Box>
                                                            {i['medication_list'].length > 0 ?
                                                                <Box sx={{ height: '310px', overflowY: "auto" }}>
                                                                    {i['medication_list'].map((item, index) => (
                                                                        <Box key={index}>
                                                                            <Box sx={{ color: '#478F96', fontWeight: 700, marginBottom: '20px' }}>{item['hos_name']}</Box>
                                                                            {item['order_list'].length > 0 ?
                                                                                <Box>
                                                                                    {item['order_list'].map((i, idx) => (
                                                                                        <Box key={idx} sx={{ display: 'flex', gridGap: 5, margin: '0 20px' }}>
                                                                                            <CircleIcon style={{ width: '5px' }} /> {i['med']}
                                                                                        </Box>
                                                                                    ))}
                                                                                </Box>
                                                                                :
                                                                                <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>ไม่พบข้อมูล</Box>
                                                                            }
                                                                        </Box>
                                                                    ))}
                                                                </Box>
                                                                :
                                                                <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>ไม่พบข้อมูล</Box>
                                                            }
                                                        </Box>
                                                        : null
                                                    }

                                                    {menuSelected[idx] === 4 ?
                                                        <Box sx={{ padding: '20px', height: '350px' }}>
                                                            <Box sx={{ color: '#478F96', fontWeight: 700, fontSize: 20 }}>การจ่ายยา</Box>
                                                            {i['allergy_list'].length > 0 ?
                                                                <Box sx={{ height: '310px', overflowY: "auto" }}>
                                                                    {i['allergy_list'].map((item, index) => (
                                                                        <Box key={index}>
                                                                            <Box sx={{ color: '#478F96', fontWeight: 700, marginBottom: '20px' }}>{item['hos_name']}</Box>
                                                                            {item['allergy_list'].length > 0 ?
                                                                                <Box>
                                                                                    {item['allergy_list'].map((i, idx) => (
                                                                                        <Box key={idx} sx={{ display: 'flex', gridGap: 5, margin: '0 20px' }}>
                                                                                            <CircleIcon style={{ width: '5px' }} /> {i['med']}
                                                                                        </Box>
                                                                                    ))}
                                                                                </Box>
                                                                                :
                                                                                <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>ไม่พบข้อมูล</Box>
                                                                            }
                                                                        </Box>
                                                                    ))}
                                                                </Box>
                                                                :
                                                                <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>ไม่พบข้อมูล</Box>
                                                            }
                                                        </Box>
                                                        : null
                                                    }
                                                </Box>
                                            </Box>
                                        ))}
                                    </Box>
                                    :
                                    <Box sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: '20vh'
                                    }}>ไม่มีข้อมูล</Box>
                                }
                            </Box>
                        }
                    </Box>


                </Paper>
            </FormProvider>
        </Box>

    )
}

export default Index
